import classNames from 'classnames';
import { Button } from 'antd';
import type { ButtonProps } from 'antd';
import type { themeColourAttributes } from '../../utils/constants';

export type StyledButtonProps = Omit<ButtonProps, 'color'> & {
	color?: keyof typeof themeColourAttributes;
	iconOnly?: boolean;
};

/**
 * Primary UI component for user interaction
 */
export const StyledButton = ({
	color = 'brand',
	iconOnly = false,
	...props
}: StyledButtonProps) => {
	const buttonClasses = classNames(
		'styled-btn',
		{ [`styled-btn-color-${color}`]: color, ['icon-only']: iconOnly },
		props.className
	);
	return (
		<Button {...props} className={buttonClasses}>
			{props.children}
		</Button>
	);
};
